import "./QuestTrainingResultModal.css";

export default function QuestTrainingResultModal({
  open = false,
  onConfirm,
}) {
  if (!open) return null;

  const title = "Session prise en compte";
  const message =
    "Votre session d'entraînement a bien été prise en compte pour la quête du jour.";

  return (
    <div className="quest-training-result" role="dialog" aria-modal="true" aria-labelledby="quest-training-result-title">
      <div className="quest-training-result__card">
        <h3
          id="quest-training-result-title"
          className="quest-training-result__title quest-training-result__title--ok"
        >
          {title}
        </h3>
        <p className="quest-training-result__message">{message}</p>
        <button type="button" className="quest-training-result__ok" onClick={onConfirm}>
          OK
        </button>
      </div>
    </div>
  );
}
